var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "self-end flex-wrap rounded-sm shadow-primary border-sm mb-4 p-4 flex w-full border-l-8",
      class: _vm.containerClasses,
    },
    [
      _c(
        "div",
        { staticClass: "w-1/2 lgLabelContainer min-w-68" },
        [
          _c("CardBodyItem", { attrs: { label: "Title", content: _vm.title } }),
          _c("CardBodyItem", {
            attrs: { label: "Budget", content: _vm.budget },
          }),
          _c("CardBodyItem", {
            attrs: { label: "Start Date", content: _vm.startDate },
          }),
          _c("CardBodyItem", {
            attrs: { label: "End Date", content: _vm.endDate },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "w-1/2 xxlLabelContainer" },
        [
          _c("CardBodyItem", {
            attrs: { label: "Requested Hours", content: _vm.requestedHours },
          }),
          _c("CardBodyItem", {
            attrs: { label: "Approved Hours", content: _vm.approvedHours },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }